const EULA_VERSION_FALLBACK = "1.0.0";

/**
 * EULA version from Fred SSO landing URLs. Canonical key is `eula_version`
 * (e.g. `/signup?orgName=MyOrg&geo=EU&eula_version=1.0`); `eulaVersion` is
 * accepted for backward compatibility.
 */
export const readEulaVersionParam = (params: URLSearchParams): string =>
  params.get("eula_version") ||
  params.get("eulaVersion") ||
  EULA_VERSION_FALLBACK;

export { EULA_VERSION_FALLBACK };

export type CrossGeoLandingParams = {
  orgName: string;
  geo: string;
  eulaVersion: string;
};

/**
 * New-org flow: `/signup?orgName=&geo=&eula_version=` — `geo` is target geo for
 * `NewOrgRequest.targetGeo`.
 */
export const getSignupCrossGeoParams = (
  search: string
): CrossGeoLandingParams | null => {
  const params = new URLSearchParams(search);
  const orgName = params.get("orgName");
  const geo = params.get("geo");
  if (!orgName || !geo) {
    return null;
  }
  return {
    orgName,
    geo,
    eulaVersion: readEulaVersionParam(params)
  };
};
